import { render } from "./add-Category.vue?vue&type=template&id=2a414bea"
import script from "./add-Category.vue?vue&type=script&lang=js"
export * from "./add-Category.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__